import React from "react";
import {
  Box,
  HStack,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Heading,
  Stack,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

// components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import { WrappedFiatWalletAction } from "components/WalletActions/FiatWalletActions";
import { CustomTab } from "../Cards/MyCard";

// Panels
import BuyNow from "./Panels/BuyNow";
import Transactions from "./Panels/Transactions";

// assets
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";

export default function HomeBuy(props) {
  const { logout, userData } = props;

  return (
    <Box>
      <Sidemenu currentPage="Home" logoutUser={logout} />
      <Header />

      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={[
              "100%",
              "100%",
              "calc(100% - 15vw)",
              "calc(100% - 20vw)",
              "calc(100% - 40vw)",
            ]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]} mb={["24px", "32px"]}>
              <HStack w="100%" justifyContent="space-between">
                <Heading>Buy</Heading>
              </HStack>
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/home">Home</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="">
                    Buy
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "32px 24px", "50px"]}
              //   mt={["24px", "10px"]}
              borderRadius={[0, "8px", "16px"]}
            >
              <Stack>
                <WrappedFiatWalletAction
                  maxW="100%"
                  w="100%"
                  userData={userData}
                />

                <Tabs isFitted mt="26px !important">
                  <TabList
                    border="none"
                    borderRadius="6px"
                    p="6px"
                    bg="#D9DBE9"
                  >
                    <CustomTab>Buy now</CustomTab>
                    <CustomTab>Transactions</CustomTab>
                  </TabList>

                  <TabPanels>
                    <TabPanel px="0">
                      <BuyNow {...props} />
                    </TabPanel>
                    <TabPanel px="0">
                      <Transactions {...props} />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Stack>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
